import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { AppProviders } from '@/app/providers'
import { useSettingsStore } from '@/store/settings.store'
import { useUIStore } from '@/store/ui.store'
import { setDocumentDirection } from '@/lib/rtl'
import '@/styles/globals.css'

/**
 * Root App component
 * Initializes global settings and providers
 */
function App() {
  const { i18n } = useTranslation()
  const { language } = useSettingsStore()
  const { setTheme } = useUIStore()

  // Initialize app settings on mount
  useEffect(() => {
    // Set initial language and direction
    i18n.changeLanguage(language)
    setDocumentDirection(language)

    // Initialize theme (default to light)
    setTheme('light')

    // Add development helpers
    if (import.meta.env.DEV) {
      // Add global debug helpers in development
      ;(window as any).__ERP_DEBUG__ = {
        stores: {
          auth: () => import('@/store/auth.store').then(m => m.useAuthStore.getState()),
          ui: () => import('@/store/ui.store').then(m => m.useUIStore.getState()),
          settings: () => import('@/store/settings.store').then(m => m.useSettingsStore.getState()),
        },
        i18n: () => i18n,
        version: '1.0.1',
      }
    }
  }, [language, i18n, setTheme])

  return <AppProviders />
}

export default App 